import React from "react";
import { Field, reduxForm, stopSubmit } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import StarRating from "../../system/fields/StarRating";

import * as validations from "../../system/utils/Validation";

let EditForm = (props, { fields }) => {
  const { handleSubmit, mode } = props;
  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>
        <section className="form-section">
          <div className="form-section-header">Personal Details</div>

          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Url *</Label>
              <Field
                name="url"
                component={TextInput}
                placeholder="url"
                type="text"
                validate={validations.required}
              />
            </FormGroup>

            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Page H1</Label>
              <Field
                name="h1"
                placeholder="Page H1"
                component={TextInput}
                type="text"
              />
            </FormGroup>
  
            <FormGroup className="col-12">
              <Label htmlFor="email">Meta Title *</Label>
              <Field
                  name="meta_title"
                  placeholder="Meta Title"
                  component={TextInput}
                  type="text"
                  validate={validations.required}
              />
            </FormGroup>
  
            <FormGroup className="col-12">
              <Label htmlFor="email">Meta Description *</Label>
              <Field
                  name="meta_description"
                  placeholder="Meta Description"
                  component={'textarea'}
                  type="text"
                  validate={validations.required}
              />
            </FormGroup>
          </div>
        </section>
      </Form>

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: "TestForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {dispatch(stopSubmit("TestForm"))}
  }
})(EditForm);

export default EditForm;



// WEBPACK FOOTER //
// ./src/containers/Seo/Form.jsx